var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLetterIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 95,
    height: 77,
    viewBox: "0 0 95 77",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 4C0 1.79086 1.79086 0 4 0H91C93.2091 0 95 1.79086 95 4V73C95 75.2091 93.2091 77 91 77H4C1.79086 77 0 75.2091 0 73V4Z",
    fill: "#020C41"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M64.1641 21.834H30.8307C28.5295 21.834 26.6641 23.6995 26.6641 26.0007V51.0007C26.6641 53.3018 28.5295 55.1673 30.8307 55.1673H64.1641C66.4652 55.1673 68.3307 53.3018 68.3307 51.0007V26.0007C68.3307 23.6995 66.4652 21.834 64.1641 21.834Z",
    stroke: "white",
    strokeWidth: 3.125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M68.3307 28.084L49.6432 39.959C49 40.362 48.2564 40.5757 47.4974 40.5757C46.7384 40.5757 45.9947 40.362 45.3516 39.959L26.6641 28.084",
    stroke: "white",
    strokeWidth: 3.125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLetterIcon);
export default __webpack_public_path__ + "static/media/letter-icon.94eaf8e4468ba93f64082326585655d7.svg";
export { ForwardRef as ReactComponent };